import React, { Component } from "react";

import {
  Card,
  Button,
  Table,
  Tooltip,
  Switch,
  Input,
  BackTop,
  Modal,
} from "antd";

import { connect } from "react-redux";
import {
  req_page_tqa_work_a_list,
  req_downloadfile_tqa_worker,
} from "../../api";

import {
  API_BASE,
  PAGE_SIZE,
  SORT_FIELD_NAME,
  SORT_UP_DOWN,
} from "../../utils/contrains";
import { usrRole } from "../../utils/dataUtil";
import { getNowAcademicYear } from "../../utils/dateUtil";

import SchoolQuailtyA01 from "./school-quailty-a01";
import SchoolQuailtyA02 from "./school-quailty-a02";
import SchoolQuailtyA03 from "./school-quailty-a03";
import SchoolQuailtyA04 from "./school-quailty-a04";
import SchoolQuailtyA05 from "./school-quailty-a05";

class ManageWorkLevelAList extends Component {
  // 基礎通用參數 //////////////////////////////////////////////
  state = {
    deviceWidth: 0,
    loading: false,
    userLevel: "NORMAL",
    items: [],
    item: {},
    pagination: {
      current: 1,
      pageSize: PAGE_SIZE,
      total: 0,
    },
    columnSort: SORT_FIELD_NAME,
    orderBy: SORT_UP_DOWN,
    searchField: "NONE",
    searchValue: "",
    filterStatus: "",
    switchStatus: true,

    domnloadFile: "",
    academicYear: getNowAcademicYear(new Date()),
    isA01Modal: false,
    isA02Modal: false,
    isA03Modal: false,
    isA04Modal: false,
    isA05Modal: false,
    isD01Modal: false,
    isD02Modal: false,
    isD03Modal: false,
    isD04Modal: false,
    isD05Modal: false,
    isD06Modal: false,
    isD07Modal: false,
    isD08Modal: false,
    isTemplateModal: false,
  };

  UNSAFE_componentWillMount() {
    this.init_columns();
  }

  componentDidMount() {
    window.addEventListener("resize", this.resize.bind(this));
    this.resize();
    this.api_page_items(1);
  }

  // 遠端數據處理 //////////////////////////////////////////////

  api_page_items = (current) => {
    this.current = current; // 保存當前頁，給其他方法可看到
    const { pageSize } = this.state.pagination;
    const {
      searchField,
      searchValue,
      columnSort,
      orderBy,
      filterStatus,
      academicYear,
    } = this.state;
    const { token, userCode, role } = this.props.user;
    var userLevel = usrRole(role);
    this.setState({ userLevel: userLevel });

    this.api_page_run(
      userCode,
      userLevel,
      current,
      pageSize,
      columnSort,
      orderBy,
      searchField,
      searchValue,
      filterStatus,
      academicYear,
      token
    );
  };

  api_page_run = async (
    userCode,
    userLevel,
    current,
    pageSize,
    columnSort,
    orderBy,
    searchField,
    searchValue,
    filterStatus,
    academicYear,
    token
  ) => {
    this.setState({ loading: true });
    const result = await req_page_tqa_work_a_list(
      userCode,
      userLevel,
      current,
      pageSize,
      columnSort,
      orderBy,
      searchField,
      searchValue,
      filterStatus,
      academicYear,
      token
    );
    //console.log(result);
    if (result.total > 0) {
      const { total } = result;
      const items = result.data;
      const pagination = {
        current: this.current,
        pageSize: this.state.pagination.pageSize,
        total,
      };
      this.setState({ items, pagination });
    } else {
      const items = [];
      const pagination = {
        current: 1,
        pageSize: this.state.pagination.pageSize,
        total: 0,
      };
      this.setState({ items, pagination });
    }
    this.setState({ loading: false });
  };

  api_downloadfile_items = async () => {
    const { userLevel, searchField, searchValue, filterStatus, academicYear } =
      this.state;
    const { token, userCode } = this.props.user;

    // download file data
    const fileUrl = await req_downloadfile_tqa_worker(
      userCode,
      userLevel,
      searchField,
      searchValue,
      filterStatus,
      academicYear,
      token
    );

    // download file link
    let a = document.createElement("a");
    a.href = API_BASE + fileUrl;
    a.target = "_blank";
    a.download = "品保作業人員清單";
    a.click();
  };

  // 數據配置設定 //////////////////////////////////////////////

  style_switch_text_tag(column) {
    let ans = "其他";
    switch (column) {
      case "A":
        ans = "學院"; // 學院
        break;
      case "B": // 中心
        ans = "中心";
        break;
      case "C":
        ans = "學系"; // 學系
        break;
      case "D":
        ans = "碩班"; //碩班
        break;
      default:
        // OTHER
        break;
    }
    return ans;
  }

  style_switch_color_tag(column) {
    let ans = "gold";
    switch (column) {
      case "A":
        ans = "#87d068"; // 學院
        break;
      case "B": // 中心
        ans = "#108ee9";
        break;
      case "C": // 學系
        ans = "magenta";
        break;
      case "D":
        ans = "#f50"; // 碩班
        break;
      default:
        ans = "gold";
        break;
    }
    return ans;
  }

  // 操作互動處理 //////////////////////////////////////////////

  resize() {
    this.setState({ deviceWidth: window.innerWidth });
  }

  handle_page_size_change = (current, size) => {
    //console.log(size)
    this.setState(
      {
        pagination: {
          current: current,
          pageSize: size,
        },
      },
      () => {
        this.api_page_items(current);
      }
    );
  };

  handle_table_change = (pagination, filters, sorter, extra) => {
    if (filters) {
      const status = [...Object.values(filters).filter(Boolean)][0];
      if (status) {
        this.setState({ filterStatus: status }, () => {
          this.api_page_items(pagination.current);
        });
      } else {
        this.setState({ filterStatus: "" }, () => {
          this.api_page_items(pagination.current);
        });
      }
    } else {
      this.api_page_items(pagination.current);
    }
  };

  handle_data_refresh = () => {
    this.api_page_items(this.current);
  };

  handle_ui_field_change = (target_key, target_field, e) => {
    const value = e.target.value;
    const item = {
      activityNid: target_key,
      setPoints: value,
      condition: target_field,
    };
    //console.log(target_key)
    this.api_modify_item(item);
  };

  handle_switch_change = (checked) => {
    // console.log(checked);
    this.setState({ switchStatus: checked }, () => {
      this.api_page_items(this.current);
    });
  };

  handle_show_ui_modal = (modal, item) => {
    switch (modal) {
      case "A01":
        this.setState({ isA01Modal: true, item });
        break;
      case "A02":
        this.setState({ isA02Modal: true, item });
        break;
      case "A03":
        this.setState({ isA03Modal: true, item });
        break;
      case "A04":
        this.setState({ isA04Modal: true, item });
        break;
      case "A05":
        this.setState({ isA05Modal: true, item });
        break;

      default:
    }
  };

  /////////////////////////////////////////////////////////////
  init_columns = () => {
    const academicYear = getNowAcademicYear(new Date());
    this.setState({ academicYear });
    this.columns = [
      {
        title: "學年度",
        dataIndex: "AcademicYear",
        width: 20,
        responsive: ["md"],
      },
      {
        title: "",
        dataIndex: "",
        width: 80,
        render: (item) => {
          const { switchStatus } = this.state;
          const { A01Status, A02Status, A03Status, A04Status, A05Status } =
            item;
          return (
            <>
              <Tooltip title="A01-校教育目標">
                <button
                  type="button"
                  className={
                    A01Status === "DONE"
                      ? "btn btn-outline-success btn-sm"
                      : "btn btn-outline-dark btn-sm"
                  }
                  onClick={() => this.handle_show_ui_modal("A01", item)}
                >
                  <i className="fa fa-align-justify"></i>
                  <span style={{ marginLeft: "2px" }}>
                    {switchStatus ? "A01-校教育目標" : "A01"}
                  </span>
                </button>
              </Tooltip>
              <Tooltip title="A02-校與各院教育目標關聯">
                <button
                  type="button"
                  className={
                    A02Status === "DONE"
                      ? "btn btn-outline-success btn-sm"
                      : "btn btn-outline-dark btn-sm"
                  }
                  onClick={() => this.handle_show_ui_modal("A02", item)}
                >
                  <i className="fa fa-align-justify"></i>
                  <span style={{ marginLeft: "2px" }}>
                    {switchStatus ? "A02-校與各院教育目標關聯" : "A02"}
                  </span>
                </button>
              </Tooltip>
              <Tooltip title="A03-學生基本素養">
                <button
                  type="button"
                  className={
                    A03Status === "DONE"
                      ? "btn btn-outline-success btn-sm"
                      : "btn btn-outline-dark btn-sm"
                  }
                  onClick={() => this.handle_show_ui_modal("A03", item)}
                >
                  <i className="fa fa-align-justify"></i>
                  <span style={{ marginLeft: "2px" }}>
                    {" "}
                    {switchStatus ? "A03-學生基本素養" : "A03"}
                  </span>
                </button>
              </Tooltip>
              <Tooltip title="A04-學生核心能力">
                <button
                  type="button"
                  className={
                    A04Status === "DONE"
                      ? "btn btn-outline-success btn-sm"
                      : "btn btn-outline-dark btn-sm"
                  }
                  onClick={() => this.handle_show_ui_modal("A04", item)}
                >
                  <i className="fa fa-align-justify"></i>
                  <span style={{ marginLeft: "2px" }}>
                    {" "}
                    {switchStatus ? "A04-學生核心能力" : "A04"}
                  </span>
                </button>
              </Tooltip>
              <Tooltip title="A05-校與各院核心能力關聯">
                <button
                  type="button"
                  className={
                    A05Status === "DONE"
                      ? "btn btn-outline-success btn-sm"
                      : "btn btn-outline-dark btn-sm"
                  }
                  onClick={() => this.handle_show_ui_modal("A05", item)}
                >
                  <i className="fa fa-align-justify"></i>
                  <span style={{ marginLeft: "2px" }}>
                    {switchStatus ? "A05-校與各院核心能力關聯" : "A05"}
                  </span>
                </button>
              </Tooltip>
            </>
          );
        },
      },
    ];
  };

  render() {
    const {
      loading,
      item,
      items,
      pagination,
      academicYear,
      isA01Modal,
      isA02Modal,
      isA03Modal,
      isA04Modal,
      isA05Modal,
    } = this.state;
    const title = (
      <>
        <Input
          placeholder="學年"
          style={{ width: 55, margin: "0 5px", backgroundColor: "LightYellow" }}
          value={academicYear}
          onChange={(event) =>
            this.setState({ academicYear: event.target.value })
          }
        />
        <Button type="primary" onClick={() => this.api_page_items(1)}>
          <i className="fas fa-search element-hidden"></i>
          <span style={{ marginLeft: "4px" }}>查詢</span>
        </Button>{" "}
        <Tooltip placement="top" title="重新整理">
          <Button type="primary" onClick={() => this.handle_data_refresh()}>
            <i className="fas fa-sync-alt"></i>
          </Button>
        </Tooltip>
      </>
    );
    return (
      <Card title={title}>
        <Switch
          checkedChildren="代碼模式"
          unCheckedChildren="文字模式"
          onChange={this.handle_switch_change}
        />
        <Table
          bordered
          scroll={{ y: 480 }}
          loading={loading}
          rowKey="Id"
          dataSource={items}
          onChange={this.handle_table_change}
          pagination={{
            ...pagination,
            responsive: true,
            showQuickJumper: true,
            showSizeChanger: true,
            pageSizeOptions: [5, 10, 20, 50, 100],
            onShowSizeChange: this.handle_page_size_change,
          }}
          columns={this.columns}
        />
        <Modal
          destroyOnClose={true}
          visible={isA01Modal}
          width={"90%"}
          onOk={() => {
            this.setState({ isA01Modal: false });
            this.handle_data_refresh();
          }}
          onCancel={() => {
            this.setState({ isA01Modal: false });
          }}
          cancelButtonProps={{ style: { display: "none" } }}
        >
          <SchoolQuailtyA01 manual={item} />
        </Modal>
        <Modal
          destroyOnClose={true}
          visible={isA02Modal}
          width={"90%"}
          onOk={() => {
            this.setState({ isA02Modal: false });
            this.handle_data_refresh();
          }}
          onCancel={() => {
            this.setState({ isA02Modal: false });
          }}
          cancelButtonProps={{ style: { display: "none" } }}
        >
          <SchoolQuailtyA02 manual={item} />
        </Modal>
        <Modal
          destroyOnClose={true}
          visible={isA03Modal}
          width={"90%"}
          onOk={() => {
            this.setState({ isA03Modal: false });
            this.handle_data_refresh();
          }}
          onCancel={() => {
            this.setState({ isA03Modal: false });
          }}
          cancelButtonProps={{ style: { display: "none" } }}
        >
          <SchoolQuailtyA03 manual={item} />
        </Modal>
        <Modal
          destroyOnClose={true}
          visible={isA04Modal}
          width={"90%"}
          onOk={() => {
            this.setState({ isA04Modal: false });
            this.handle_data_refresh();
          }}
          onCancel={() => {
            this.setState({ isA04Modal: false });
          }}
          cancelButtonProps={{ style: { display: "none" } }}
        >
          <SchoolQuailtyA04 manual={item} />
        </Modal>
        <Modal
          destroyOnClose={true}
          visible={isA05Modal}
          width={"90%"}
          onOk={() => {
            this.setState({ isA05Modal: false });
            this.handle_data_refresh();
          }}
          onCancel={() => {
            this.setState({ isA05Modal: false });
          }}
          cancelButtonProps={{ style: { display: "none" } }}
        >
          <SchoolQuailtyA05 manual={item} />
        </Modal>
        <BackTop visibilityHeight="80" />
      </Card>
    );
  }
}

export default connect(
  (state) => ({ user: state.user }),
  {}
)(ManageWorkLevelAList);
